
import { LineChart, History, ShieldCheck } from "lucide-react";
import ProcessCard from "./ProcessCard";

const OngoingMonitoring = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
      <ProcessCard 
        icon={<LineChart className="w-6 h-6 text-[#1B2F47]" />} 
        title="Performance Monitoring" 
        content="Real-time tracking of performance and risk indicators to identify deviations or issues." 
      />
      <ProcessCard 
        icon={<History className="w-6 h-6 text-[#1B2F47]" />} 
        title="Periodic Reassessment" 
        content="Regular review of strategies to confirm they meet original benchmarks and risk criteria." 
      />
      <ProcessCard 
        icon={<ShieldCheck className="w-6 h-6 text-[#1B2F47]" />} 
        title="Compliance Checks" 
        content="Vigilant enforcement of platform rules and industry regulations." 
      />
    </div>
  );
};

export default OngoingMonitoring;
